// extracted by mini-css-extract-plugin
export default {"websiteName":"WebSiteName_websiteName__J10cT","fadeIn":"WebSiteName_fadeIn__-5pKE","hoverLineLink":"WebSiteName_hoverLineLink__qg8YX"};